// extracted by mini-css-extract-plugin
export var container = "HeroInformation-module--container--17fb4";
export var desktop_only = "HeroInformation-module--desktop_only--e35aa";
export var information = "HeroInformation-module--information--c51d6";
export var title_wrapper = "HeroInformation-module--title_wrapper--2896a";